import AuthorHome from '@/pages/author/pages/home'
import AuthorClients from '@/pages/author/pages/clients'
import AuthorEvents from '@/pages/author/pages/events'
import AuthorCompanies from '@/pages/author/pages/companies'
import AuthorBBook from '@/pages/author/pages/bbook'
import AuthorAccountant from '@/pages/author/pages/accountant'
import AuthorProfit from '@/pages/author/pages/profit/AuthorProfit'
import AuthorProgs from '@/pages/author/pages/progs'
import AuthorStays from '@/pages/author/pages/stays'
import AuthorOffsets from '@/pages/author/pages/offsets/AuthorOffsets'
import AuthorAdmin from '@/pages/author/pages/admin/AuthorAdmin'

export default {
  routes: [
    {
      path: 'home',
      name: 'AuthorHome',
      meta: {
        icon: {
          default: 'fal fa-plane-departure',
          active: 'fa-plane-departure'
        },
        label: 'ホーム',
        permit: 'home'
      },
      component: AuthorHome
    },
    {
      path: 'clients',
      name: 'AuthorClients',
      meta: {
        icon: {
          default: 'fal fa-users',
          active: 'fa-users'
        },
        label: '顧客一覧',
        permit: 'clients'
      },
      component: AuthorClients
    },
    {
      path: 'events',
      name: 'AuthorEvents',
      meta: {
        icon: {
          default: 'fal fa-calendar-star',
          active: 'fa-calendar-star'
        },
        label: '予定一覧',
        permit: 'events'
      },
      component: AuthorEvents
    },
    {
      path: 'companies',
      name: 'AuthorCompanies',
      meta: {
        icon: {
          default: 'fal fa-building',
          active: 'fa-building'
        },
        label: '企業一覧',
        permit: 'companies'
      },
      component: AuthorCompanies
    },
    {
      path: 'bbook',
      name: 'AuthorBBook',
      meta: {
        icon: {
          default: 'fal fa-credit-card',
          active: 'fa-credit-card'
        },
        label: '通帳・カード',
        permit: 'bbook'
      },
      component: AuthorBBook
    },
    {
      path: 'accountant',
      name: 'AuthorAccountant',
      meta: {
        icon: {
          default: 'fal fa-hands-usd',
          active: 'fa-hands-usd'
        },
        label: '振り分け',
        permit: 'accountant'
      },
      component: AuthorAccountant
    },
    {
      path: 'profit',
      name: 'AuthorProfit',
      meta: {
        icon: {
          default: 'fal fa-yen-sign',
          active: 'fa-yen-sign'
        },
        label: '売上・残高',
        permit: 'profit'
      },
      component: AuthorProfit
    },
    {
      path: 'progs',
      name: 'AuthorProgs',
      meta: {
        icon: {
          default: 'fal fa-school',
          active: 'fa-school'
        },
        label: '学校手配',
        permit: 'progs'
      },
      component: AuthorProgs
    },
    {
      path: 'stays',
      name: 'AuthorStays',
      meta: {
        icon: {
          default: 'fal fa-hotel',
          active: 'fa-hotel'
        },
        label: '滞在手配',
        permit: 'stays'
      },
      component: AuthorStays
    },
    {
      path: 'offsets',
      name: 'AuthorOffsets',
      meta: {
        icon: {
          default: 'fal fa-minus-circle',
          active: 'fa-minus-circle'
        },
        label: '相殺手配',
        permit: 'offsets'
      },
      component: AuthorOffsets
    },
    {
      path: 'admin',
      name: 'AuthorAdmin',
      meta: {
        icon: {
          default: 'fal fa-user-tie',
          active: 'fa-user-tie'
        },
        label: '管理者',
        permit: 'admin'
      },
      component: AuthorAdmin
    }
  ]
}
